module.exports = __webpack_public_path__ + "img/img_brand_hover_3.9bd2303f.svg";